import { NotFound } from 'components/404/NotFound';

export const NotFoundView = NotFound;
